// Full-document render of the sealy WriteReviewPage: PageSkeleton (the React
// document shell) wrapping the customer-review__header container around the
// shared write-review SPA.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as WriteReviewSPA } from "./WriteReviewTemplate";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton).
export const Template = (
    props: templates.WriteReviewPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div className="customer-review__header">
            <WriteReviewSPA {...props} />
        </div>
    </PageSkeleton>
);
